import React, { createContext, useCallback, useMemo, useState } from "react";

export const LinkingContext = createContext({
  data: [],
  addData: (_id = '', _data = {}) => { },
});

export const LinkingProvider = ({ children }) => {
  const [data, setData] = useState({});

  const addData = useCallback((id = '', data = []) => {
    setData(prev => ({ ...prev, [id]: data.map((d, i) => ({ ...d, key: `${d.datastakeId}-${i}` })) }));
  }, []);

  const value = useMemo(() => ({ data, addData }), [data, addData])

  return (
    <LinkingContext.Provider
      value={value}
    >
      {children}
    </LinkingContext.Provider>
  )
};

